/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartI
 */
export interface ExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartI {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartI
     */
    ack_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartI
     */
    ack_id_uuid?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartI
     */
    row_order?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartI
     */
    plan_transfer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartI
     */
    plan_transfer_ein?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartI
     */
    plan_transfer_pn?: string;
}

/**
 * Check if a given object implements the ExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartI interface.
 */
export function instanceOfExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartI(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartIFromJSON(json: any): ExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartI {
    return ExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartIFromJSONTyped(json, false);
}

export function ExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartIFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartI {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ack_id': !exists(json, 'ack_id') ? undefined : json['ack_id'],
        'ack_id_uuid': !exists(json, 'ack_id_uuid') ? undefined : json['ack_id_uuid'],
        'row_order': !exists(json, 'row_order') ? undefined : json['row_order'],
        'plan_transfer_name': !exists(json, 'plan_transfer_name') ? undefined : json['plan_transfer_name'],
        'plan_transfer_ein': !exists(json, 'plan_transfer_ein') ? undefined : json['plan_transfer_ein'],
        'plan_transfer_pn': !exists(json, 'plan_transfer_pn') ? undefined : json['plan_transfer_pn'],
    };
}

export function ExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartIToJSON(value?: ExecRiskApiAppCoreModelsScansLongForm5500ScheduleHDefPartI | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ack_id': value.ack_id,
        'ack_id_uuid': value.ack_id_uuid,
        'row_order': value.row_order,
        'plan_transfer_name': value.plan_transfer_name,
        'plan_transfer_ein': value.plan_transfer_ein,
        'plan_transfer_pn': value.plan_transfer_pn,
    };
}

